'use strict';

import newsHeader from './header/news_header.vue'
import HeaderTop from './header/header-top.vue'
import Header from './header/header.vue'
import studentStyle from './news/student_style.vue'
import projectView from './news/project_view.vue'
import studentView from './news/student_view.vue'
import focusBar from './news/focus_side_bar.vue'
import scorllTop from './news/scroll_top.vue'


const Coms = {
    newsHeader,
    Header,
    HeaderTop,
    studentStyle,
    projectView,
    studentView,
    focusBar,
    scorllTop
  }

// vue批量引入全局组件
const PageComs = {
  install(Vue) {
    for (let key in Coms) {
      Vue.component(key, Coms[key]);
    }
  }
}

export default PageComs
